import { Trans, useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useAccount } from 'state/Account'
import { useRestaurantsByStatus, reopenRestaurants } from 'state/Restaurants'
import { FixedWarning } from './FixedWarning'

export default function DisabledOrderingAlert() {
	const { t }    = useTranslation()
	const dispatch = useDispatch()
	const account  = useAccount()

	const { active, closed, allClosed, total } = useRestaurantsByStatus()

	async function doEnable() {
		if (active) {
			return await dispatch(reopenRestaurants([active.id]))
		} else {
			const xLocations = account.strLocation(closed.length, total)
			if (window.confirm(t('This will enable all order types for {{xLocations}}.\nAre you sure?', { xLocations }))) {
				return await dispatch(reopenRestaurants(closed.map(r => r.id)))
			}
		}
	}

	const disabled  = t('disabled')
	const partially = t('partially disabled')
	let msg, status, xLocations
	if (active) { //ignore if the active place is not closed
		if (allClosed.includes(active)) {
			status = disabled
		} else if (closed.includes(active)) {
			status = partially
		}
	} else {
		if (allClosed.length) {
			status     = disabled
			xLocations = account.strLocation(allClosed.length, total)
		} else if (closed.length) {
			status     = partially
			xLocations = account.strLocation(closed.length, total)
		}
	}

	if (total == 1) { //no need to say "all locations" when there's just one
		xLocations = null
	}

	if (status) {
		if (xLocations) {
			msg = <Trans>Ordering is <b>{{ disabled: status }}</b> at {{ xLocations }}.</Trans>
		} else {
			msg = <Trans>Ordering is <b>{{ disabled: status }}</b>.</Trans>
		}
	}

	return <FixedWarning icon="power-off" btnTxt={t('Enable')} show={!!msg} action={doEnable} children={msg}/>
}
